module.exports = __webpack_public_path__ + "static/media/remove-icon.ffbcde77.svg";